export default {
    name: 'Home'
}
